// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"282":"48e80b2d935dbb5e40ac","919":"4e3395173b7b43bf16ca"}[chunkId] + ".js";
};